import React, { useEffect } from "react";
import clsx from "clsx";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const Tooltip = ({ fadeTooltip }) => {

  const keypad = useSelector( state => state.keypad );

  const { t } = useTranslation();

  useEffect(() => {
    setTimeout(fadeTooltip, 3000);
  }, []);

  return (
    <div 
      style={{zIndex: 99}}
      className={ clsx( 'tooltip', 'arr_tip', 2 === keypad.arrowKeyTooltipStatus && 'disappear' ) } 
    >
      <span dangerouslySetInnerHTML={{ __html: t('LC_05_20.msg019') }} />
      <button type="button" className="btn-closeTooltip" onClick={fadeTooltip} />
    </div>
  );
};

export default Tooltip;
